export default "__VITE_ASSET__aZV32PvJ__"